import type { MenuItem } from "@/layouts/default-layout/config/types";
import { PermissonEnum, ModuleEnum } from "~/constants/systemEnum";
import { UserTypeEnum } from "~/constants/enum";
const MainMenuConfig: Array<MenuItem> = [
    {
        pages: [
            {
                heading: "Trang tổng quan",
                route: "/",
                keenthemesIcon: "chart-simple-3",
                bootstrapIcon: "bi-app-indicator",
            },
        ],
    },
    {
        heading: "Quản lý",
        route: "/",
        pages: [
            {
                heading: "Quản lý đầu vào",
                route: "/input",
                keenthemesIcon: "people",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.Student,
            },
            {
                heading: "Quản lý sinh viên",
                route: "/student",
                keenthemesIcon: "people",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.Student,
                persmisions: [PermissonEnum.Ctsv, PermissonEnum.Accounting]
            },
            {
                heading: "Phiếu thu",
                route: "/receipt",
                keenthemesIcon: "dollar",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.Student,
            },
            {
                heading: "Theo dõi học phí",
                route: "/receipt/payment-tracking",
                keenthemesIcon: "dollar",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.Student,
            },
            {
                heading: "Quản lý lớp học",
                route: "/class",
                keenthemesIcon: "book",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.Class,
            }
        ],
    },
    {
        heading: "Thống kê",
        route: "/statistic",
        pages: [
            {
                heading: "Thống kê tình trạng",
                route: "/statistic/student-status",
                module: ModuleEnum.StudentStatus,
                persmisions: [PermissonEnum.Allow]
            }
        ],
    },
    {
        heading: "Hệ thống",
        route: "/apps",
        pages: [
            {
                sectionTitle: "Quản lý danh mục",
                route: "/category",
                keenthemesIcon: "category",
                bootstrapIcon: "bi-printer",
                sub: [
                    {
                        heading: "Danh sách năm học",
                        route: "/academic-year",
                        keenthemesIcon: "abstract-29",
                        bootstrapIcon: "bi-layers",
                        module: ModuleEnum.Category
                    },
                    {
                        heading: "Hệ đào tạo",
                        route: "/category/1",
                        module: ModuleEnum.Category,
                    },
                    {
                        heading: "Cơ sở đào tạo",
                        route: "/category/6",
                        module: ModuleEnum.Category,
                    },
                    {
                        heading: "Khoa đào tạo",
                        route: "/category/5",
                        module: ModuleEnum.Category,
                    },
                    {
                        heading: "Ngành học",
                        route: "/category/2",
                        module: ModuleEnum.Category,
                    },
                    {
                        heading: "Loại giấy tờ",
                        route: "/category/3",
                        module: ModuleEnum.Category,
                    },
                    {
                        heading: "Lý do",
                        route: "/category/4",
                        module: ModuleEnum.Category,
                    },
                    {
                        heading: "Biểu phí",
                        route: "/fee-schedule",
                        module: ModuleEnum.Category,
                    },
                    {
                        heading: "Học bổng",
                        route: "/scholar-ship",
                        module: ModuleEnum.Category,
                    },
                    {
                        heading: "Tài khoản ngân hàng",
                        route: "/bank-account",
                        module: ModuleEnum.Category,
                    },
                ],
            },
            {
                sectionTitle: "Tài khoản",
                route: "/customers",
                keenthemesIcon: "profile-user",
                bootstrapIcon: "bi-printer",
                sub: [
                    {
                        heading: "Danh sách tài khoản",
                        route: "/account",
                        module: ModuleEnum.User,
                    },
                    {
                        heading: "Nhóm tài khoản",
                        route: "/role",
                        module: ModuleEnum.Role,
                    },
                ],
            },
            {
                heading: "Cấu hình",
                route: "/config",
                keenthemesIcon: "setting-2",
                bootstrapIcon: "bi-layers",
                module: ModuleEnum.Config,
            },
            {
                heading: "Thông báo",
                route: "/notifications",
                keenthemesIcon: "notification",
                bootstrapIcon: "bi-layers",
            },
            //{
            //    heading: "Lịch sử hành động",
            //    route: "/activity-log",
            //    keenthemesIcon: "pulse",
            //    bootstrapIcon: "bi-layers",
            //    module: ModuleEnum.ActivityLog,
            //},
        ],
    },
];

export default MainMenuConfig;

export function getAllChildModule() {
    const { $isPermission } = useNuxtApp();
    let allChildModule: Array<MenuItem> = [];
    MainMenuConfig.forEach((item) => {
        if (item.pages) {
            item.pages.forEach((page) => {
                if (page.sub) {
                    allChildModule = allChildModule.concat(
                        (page.sub ?? []).filter(
                            (c) => !c.module || $isPermission(c.module, PermissonEnum.Allow)
                        )
                    );
                }
            });
        }
        if (item.sub) {
            allChildModule = allChildModule.concat(
                (item.sub ?? []).filter(
                    (c) => !c.module || $isPermission(c.module, PermissonEnum.Allow)
                )
            );
        }
        if (!item.pages && !item.sub) {
            allChildModule.push(item);
        }
    });

    return allChildModule;
}
